var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlertActivity(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-232.647 -477.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "#e16c1e",
    opacity: 0.372,
    rx: 6,
    transform: "translate(232.647 477.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e15f1e",
    d: "M12.21 11H.791a.78.78 0 0 1-.723-.321.79.79 0 0 1 .1-.794L5.816.476A.838.838 0 0 1 6.506 0a.822.822 0 0 1 .679.468l5.649 9.424a.788.788 0 0 1 .1.788.781.781 0 0 1-.724.32zM6.5 8.034a.751.751 0 0 0-.761.808.8.8 0 0 0 .216.59.775.775 0 0 0 1.313-.59.751.751 0 0 0-.768-.808zm0-5.482a.519.519 0 0 0-.377.172 1.027 1.027 0 0 0-.25.739l.114 3.011c.02.5.248.908.51.908s.493-.407.51-.908l.114-3.011a1.019 1.019 0 0 0-.246-.739.517.517 0 0 0-.375-.173z",
    transform: "translate(237.647 482.5)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertActivity);
export default __webpack_public_path__ + "static/media/alertActivity.745d72c51dde2854d770cb749d616e5b.svg";
export { ForwardRef as ReactComponent };